

export default class BreathingTranslationsResponse  {
	Id: number = 0;
	CategoryName?: string = '';
	Name?: string = '';
	Description?: string = '';
	LangCode?: string = '';
	constructor(obj?: Partial<BreathingTranslationsResponse>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
